"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4094],{

/***/ 64094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AM": function() { return /* binding */ DefaultHubspotForm; }
});

// UNUSED EXPORTS: HubspotForm, fieldsFromHubspotResponse

// NAMESPACE OBJECT: ./node_modules/@trustpilot/businesssite-components/components/HubspotForm/HubspotCountryInput.js
var HubspotCountryInput_namespaceObject = {};
__webpack_require__.r(HubspotCountryInput_namespaceObject);
__webpack_require__.d(HubspotCountryInput_namespaceObject, {
  "X": function() { return HubspotCountryInput; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(11987);
var native_url_default = /*#__PURE__*/__webpack_require__.n(native_url);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/ilenia/dist/useTranslations.js
var useTranslations = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Inputs/index.js + 6 modules
var Inputs = __webpack_require__(22691);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/index.js + 4 modules
var NewBrandInputs = __webpack_require__(88518);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandButtons/index.js
var NewBrandButtons = __webpack_require__(95641);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Buttons/index.js
var Buttons = __webpack_require__(23012);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/cookies.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var parseCookies = function parseCookies(cookies) {
  if (!cookies) {
    return {};
  }

  return cookies.split(';').map(function (set) {
    return set.split('=');
  }).reduce(function (accumulator, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return _objectSpread(_objectSpread({}, accumulator), {}, (0,defineProperty/* default */.Z)({}, key.trim(), value.trim()));
  }, {});
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/constants/heights.js
var heights = __webpack_require__(89186);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Loading.js
var Loading = __webpack_require__(74605);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/tracking.js
var tracking = __webpack_require__(14364);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/regex.js
var regex = __webpack_require__(83772);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/HubspotForm/HubspotCountryInput.js


function HubspotCountryInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HubspotCountryInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HubspotCountryInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HubspotCountryInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var HubspotCountryInput = function HubspotCountryInput(props) {
  if (props.newBrand) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NewBrandInputs/* InlineCountryCodeInput */.xg, HubspotCountryInput_objectSpread({
      countryMenuItems: props.countryOptions
    }, props));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Inputs/* InlineCountryCodeInput */.xg, HubspotCountryInput_objectSpread({
    countryMenuItems: props.countryOptions
  }, props));
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandRichText.js + 2 modules
var NewBrandRichText = __webpack_require__(20014);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Box.js
var Box = __webpack_require__(15458);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/HubspotForm/index.js






function HubspotForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HubspotForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HubspotForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HubspotForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HubspotForm__LoadingWrapper",
  componentId: "sc-1166dpp-0"
})(["text-align:center;margin-bottom:", "px;"], heights/* SPACING_MOBILE */.KA);
var hubspotInputMap = {
  email: Inputs/* FormikTextInput */.WA,
  single_line_text: Inputs/* FormikTextInput */.WA,
  phone: Inputs/* FormikTextInput */.WA,
  dropdown: Inputs/* FormikDropdown */.tl,
  multi_line_text: Inputs/* FormikTextArea */.NO,
  booleancheckbox: Inputs/* FormikCheckbox */.ml,
  country_code_phone: HubspotCountryInput
};
var newBrandInputMap = {
  email: NewBrandInputs/* FormikTextInput */.WA,
  single_line_text: NewBrandInputs/* FormikTextInput */.WA,
  phone: NewBrandInputs/* FormikTextInput */.WA,
  dropdown: NewBrandInputs/* FormikDropdown */.tl,
  multi_line_text: Inputs/* FormikTextArea */.NO,
  booleancheckbox: Inputs/* FormikCheckbox */.ml,
  country_code_phone: function country_code_phone(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(HubspotCountryInput, HubspotForm_objectSpread(HubspotForm_objectSpread({}, props), {}, {
      newBrand: true
    }));
  }
};

var inputFromField = function inputFromField(field, inputMap) {
  var InputComponent = inputMap[field.fieldType];

  if (field.useCountryCodeSelect) {
    InputComponent = inputMap.country_code_phone;
  }

  return InputComponent;
};

var fieldsFromHubspotResponse = function fieldsFromHubspotResponse(response) {
  var fieldGroups = response.fieldGroups;
  return fieldGroups ? fieldGroups.reduce(function (acc, _ref) {
    var fields = _ref.fields;
    return [].concat((0,toConsumableArray/* default */.Z)(acc), (0,toConsumableArray/* default */.Z)(fields));
  }, []) : [];
};

var initialValuesForFields = function initialValuesForFields(fields) {
  return fields.reduce(function (acc, _ref2) {
    var fieldType = _ref2.fieldType,
        name = _ref2.name,
        hidden = _ref2.hidden,
        defaultValues = _ref2.defaultValues;
    var params = native_url_default().parse(location.href, true).query;

    if (['single_line_text', 'email', 'phone'].includes(fieldType)) {
      acc[name] = '';
    }

    if (fieldType === 'dropdown') {
      acc[name] = hidden && defaultValues !== null && defaultValues !== void 0 && defaultValues.length ? defaultValues[0] : undefined;
    }

    if (name.includes('utm')) {
      acc[name] = params[name] || parseCookies(document.cookie)[name];
    }

    if (name.includes('cta')) {
      acc[name] = params.cta;
    }

    if (name.includes('gclid')) {
      acc[name] = params.gclid;
    }

    if (name.includes('last_conversion_url')) {
      acc[name] = window.location.href;
    }

    return acc;
  }, {});
};

var generateValidation = function generateValidation(fields, translations) {
  return function (values) {
    var errors = {};
    fields.forEach(function (_ref3) {
      var required = _ref3.required,
          name = _ref3.name,
          useCountryCodeSelect = _ref3.useCountryCodeSelect;

      if (name.toLowerCase() === 'phone' && useCountryCodeSelect && !values['country']) {
        errors['country'] = true;
      }

      if (required && !values[name]) {
        switch (name.toLowerCase()) {
          case 'email':
            errors[name] = translations['forms/fields/email/missing'];
            break;

          case 'website':
            errors[name] = translations['forms/fields/website/missing'];
            break;

          case 'phone':
            errors[name] = translations['forms/fields/phone/missing'];
            break;

          case 'firstname':
            errors[name] = translations['forms/fields/firstname/missing'];
            break;

          case 'lastname':
            errors[name] = translations['forms/fields/lastname/missing'];
            break;

          case 'company':
            errors[name] = translations['forms/fields/companyname/missing'];
            break;

          default:
            errors[name] = translations['forms/error/missing'];
            break;
        }
      } else if (name === 'email' && !regex/* emailRegex.test */.HN.test(values[name])) {
        errors[name] = translations['forms/fields/email/invalid'];
      } else if (name === 'website' && !regex/* domainRegex.test */.Zf.test(values[name])) {
        errors[name] = translations['forms/fields/website/invalid'];
      } else if (name === 'phone' && !regex/* phoneRegex.test */.n_.test(values[name])) {
        errors[name] = translations['forms/fields/phone/invalid'];
      } else if ((name === 'company' || name === 'lastname' || name === 'firstname') && values[name].length > 128) {
        errors[name] = translations['forms/fields/firstname/invalid'];
      }
    });
    return errors;
  };
};

var HubspotForm = function HubspotForm(_ref4) {
  var formId = _ref4.formId,
      children = _ref4.children,
      submitEvent = _ref4.submitEvent,
      formEventName = _ref4.formEventName,
      submitCallback = _ref4.submitCallback,
      _ref4$initialValues = _ref4.initialValues,
      initialValues = _ref4$initialValues === void 0 ? {} : _ref4$initialValues,
      apiGetUrl = _ref4.apiGetUrl,
      apiPutUrl = _ref4.apiPutUrl,
      initializeCountryFromIP = _ref4.initializeCountryFromIP,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className;

  var _useState = (0,react.useState)([]),
      fields = _useState[0],
      setFields = _useState[1];

  var _useState2 = (0,react.useState)(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)('United States'),
      initialCountryValue = _useState3[0],
      setUserCountry = _useState3[1];

  var _useTranslations = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations2 = (0,slicedToArray/* default */.Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  (0,react.useEffect)(function () {
    var fetchForm = /*#__PURE__*/function () {
      var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var response, hubspotFields, _yield$axios$get, userCountry;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios_default().get(apiGetUrl || "/api/hubspot-form/".concat(formId));

              case 2:
                response = _context.sent;
                hubspotFields = fieldsFromHubspotResponse(response.data);
                _context.prev = 4;

                if (!initializeCountryFromIP) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return axios_default().get('/api/get-user-country');

              case 8:
                _yield$axios$get = _context.sent;
                userCountry = _yield$axios$get.data.country;
                setUserCountry(HubspotCountryInput_namespaceObject.countriesToPhoneCode[userCountry || 'US'].split('|')[1]);

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);
                setUserCountry(HubspotCountryInput_namespaceObject.countriesToPhoneCode.US.split('|')[1]);

              case 16:
                setFields(hubspotFields);
                setLoading(false);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 13]]);
      }));

      return function fetchForm() {
        return _ref5.apply(this, arguments);
      };
    }();

    fetchForm();
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values, _ref6) {
      var setErrors, _yield$axios$get2, _yield$axios$get2$dat, status, substatus, _ref8, label, value, action, category, placement, errorString;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setErrors = _ref6.setErrors;
              _context2.next = 3;
              return axios_default().get("/api/zerobounce?email=".concat(values.email));

            case 3:
              _yield$axios$get2 = _context2.sent;
              _yield$axios$get2$dat = _yield$axios$get2.data;
              status = _yield$axios$get2$dat.status;
              substatus = _yield$axios$get2$dat.substatus;

              if (!['valid', 'unknown', 'catch-all'].includes(status)) {
                _context2.next = 19;
                break;
              }

              setLoading(true);
              _context2.next = 11;
              return axios_default().put(apiPutUrl || "/api/hubspot-form/".concat(formId), HubspotForm_objectSpread(HubspotForm_objectSpread({}, values), {}, {
                pageUrl: window.location.href,
                pageName: document.title
              }));

            case 11:
              _ref8 = submitEvent || {}, label = _ref8.label, value = _ref8.value, action = _ref8.action, category = _ref8.category, placement = _ref8.placement;

              if (label || value || action || category || placement) {
                (0,tracking/* trackFormSubmitted */.rV)({
                  action: action,
                  label: label,
                  value: value,
                  category: category,
                  placement: placement,
                  form: formEventName,
                  email: values.email,
                  phone: values.phone,
                  firstname: values.firstname
                });
              }

              if (!(typeof submitCallback === 'function')) {
                _context2.next = 16;
                break;
              }

              _context2.next = 16;
              return submitCallback(values);

            case 16:
              setLoading(false);
              _context2.next = 21;
              break;

            case 19:
              errorString = translations["forms/fields/email/".concat(substatus)] || translations["forms/fields/email/".concat(status)] || translations["forms/fields/email/invalid"];
              setErrors({
                email: errorString
              });

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x, _x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var validate = generateValidation(fields, translations);
  return loading && fields ? /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loading/* SpinnerLoader */.i, {})
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
    onSubmit: onSubmit,
    validate: validate,
    validateOnBlur: false,
    initialValues: HubspotForm_objectSpread(HubspotForm_objectSpread(HubspotForm_objectSpread({}, initialValuesForFields(fields)), initialValues), initializeCountryFromIP && {
      country: initialCountryValue
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
      className: className,
      children: children(fields)
    })
  });
};

var richtextPrimitiveRenderer = (0,defineProperty/* default */.Z)({}, dist.BLOCKS.HR, function () {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
    as: "hr",
    my: 4,
    border: "none",
    height: "1px",
    bg: "black"
  });
});

var DefaultHubspotForm = function DefaultHubspotForm(props) {
  var _useTranslations3 = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations4 = (0,slicedToArray/* default */.Z)(_useTranslations3, 1),
      translations = _useTranslations4[0];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(HubspotForm, HubspotForm_objectSpread(HubspotForm_objectSpread({}, props), {}, {
    children: function children(fields) {
      var countryField = fields.find(function (_ref9) {
        var name = _ref9.name;
        return name === 'country';
      });
      var phoneField = fields.find(function (_ref10) {
        var name = _ref10.name;
        return name === 'phone';
      });
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [props.header && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
          mb: 5,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewBrandRichText/* NewBrandRichText */.xF, HubspotForm_objectSpread(HubspotForm_objectSpread({}, props.header), {}, {
            customPrimitiveRenderer: richtextPrimitiveRenderer
          }))
        }), fields.map(function (field) {
          if (field.name === 'country' && phoneField !== null && phoneField !== void 0 && phoneField.useCountryCodeSelect) {
            return null;
          }

          var fieldJsx = /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
            name: field.name,
            label: field.label,
            options: field.options,
            countryOptions: countryField === null || countryField === void 0 ? void 0 : countryField.options,
            onFocus: props.formEventName ? function (e) {
              return (0,tracking/* trackFormFieldFocus */.L7)(e, props.formEventName);
            } : undefined,
            type: field.hidden ? 'hidden' : undefined,
            initialCountryValue: field.initialCountryValue,
            useCountryCodeSelect: field.useCountryCodeSelect,
            component: field.hidden ? 'input' : inputFromField(field, props.newBrand ? newBrandInputMap : hubspotInputMap)
          }, field.name);

          return field.hidden ? fieldJsx : /*#__PURE__*/(0,jsx_runtime.jsx)(Inputs/* FormLine */.L6, {
            children: fieldJsx
          }, field.name);
        }), props.newBrand ? /*#__PURE__*/(0,jsx_runtime.jsx)(NewBrandButtons/* Button */.z, {
          as: "button",
          $uiType: "solid",
          $colorVariant: "primary",
          width: 1,
          py: 4,
          children: translations['forms/submit'] || props.submitText || 'Submit'
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* SolidButton */.gg, {
          block: true,
          fullWidth: true,
          as: "button",
          type: "submit",
          color: "blue-light",
          text: translations['forms/submit'] || props.submitText || 'Submit'
        }), props.disclaimer && /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
          linkColor: "blue-300",
          mt: 4,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewBrandRichText/* NewBrandRichText */.xF, HubspotForm_objectSpread({}, props.disclaimer))
        })]
      });
    }
  }));
};

/***/ }),

/***/ 74605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SpinnerLoader; }
/* harmony export */ });
/* unused harmony export Loading */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var Loading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Loading",
  componentId: "sc-ukbs1x-0"
})(["border-radius:50%;width:2.5em;height:2.5em;color:", ";font-size:10px;margin:80px auto;position:relative;text-indent:-9999em;transform:translateZ(0);animation:load 1.8s infinite ease-in-out;animation-fill-mode:both;animation-delay:-0.16s;&::before,&::after{border-radius:50%;width:2.5em;height:2.5em;content:'';position:absolute;top:0;animation:load 1.8s infinite ease-in-out;animation-fill-mode:both;}&::before{left:-3.5em;animation-delay:-0.32s;}&::after{left:3.5em;}@keyframes load{0%,80%,100%{box-shadow:0 2.5em 0 -1.3em;}40%{box-shadow:0 2.5em 0 0;}}text-align:center;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.bluePrimary;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
  displayName: "Loading__Wrapper",
  componentId: "sc-ukbs1x-1"
})(["animation:rotate 2s linear infinite;width:32px;height:32px;@keyframes rotate{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"]);
var Line = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].circle.withConfig */ .ZP.circle.withConfig({
  displayName: "Loading__Line",
  componentId: "sc-ukbs1x-2"
})(["stroke-width:12;stroke-dasharray:300;stroke-dashoffset:600;stroke-linecap:round;stroke-miterlimit:10;stroke:", ";fill:none;animation:dash 1.6s cubic-bezier(0.4,0.15,0.6,0.85) infinite;@keyframes dash{0%{stroke-dashoffset:600;}100%{stroke-dashoffset:0;}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.bluePrimary;
});
var SpinnerLoader = function SpinnerLoader() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, {
    viewBox: "0 0 150 150",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Line, {
      r: "60",
      cx: "75",
      cy: "75"
    })
  });
};

/***/ }),

/***/ 55573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AZ": function() { return /* binding */ InputLabel; },
/* harmony export */   "Fy": function() { return /* binding */ StyledInput; },
/* harmony export */   "SP": function() { return /* binding */ InputWrapper; },
/* harmony export */   "cp": function() { return /* binding */ FieldError; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);
/* harmony import */ var _Inputs_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75825);



var StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "Common__StyledInput",
  componentId: "sc-1n6n5jk-0"
})(["", " ", " ", " ", ""], function (_ref) {
  var isErrored = _ref.isErrored,
      theme = _ref.theme,
      floatLabel = _ref.floatLabel;
  return "\n    width: 100%;\n    height: 100%;\n    border: 1px solid ".concat(theme.colors['green-100'], ";\n    border-radius: 22px;\n    font-size: ").concat(theme.fontSizes.xs, ";\n    transition: outline .1s ease-in;\n    padding: ").concat(floatLabel ? '18px 12px 6px 12px' : '12px', ";\n    \n    outline: 1px solid ").concat(isErrored ? theme.colors['red-400'] : 'transparent', ";\n    \n    &:focus {\n      outline: 1px solid ").concat(isErrored ? theme.colors['red-400'] : theme.colors['blue-300'], ";\n    }\n    &:disabled {\n      background-color: ").concat(theme.colors['gray-700'], ";\n    }\n    ");
}, function (_ref2) {
  var textOverflowEllipsis = _ref2.textOverflowEllipsis;
  return textOverflowEllipsis && "\n    text-overflow: ellipsis;\n    padding-right: 30px;\n  ";
}, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .border */ .Cg);
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Common__InputWrapper",
  componentId: "sc-1n6n5jk-1"
})(["", ""], function (_ref3) {
  var isErrored = _ref3.isErrored,
      errorInLabel = _ref3.errorInLabel;
  return "\n    width: 100%;\n    position: relative;\n    ".concat(isErrored && !errorInLabel ? 'margin-bottom: 4px;' : '', "\n  ");
});
var InputLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "Common__InputLabel",
  componentId: "sc-1n6n5jk-2"
})(["", " ", " animation:", ";"], function (_ref4) {
  var paddingFloat = _ref4.paddingFloat,
      theme = _ref4.theme;
  return "\n    position: absolute;\n    color: ".concat(theme.colors['gray-400'], ";\n    pointer-events: none;\n    font-size: ").concat(theme.fontSizes.xs, ";\n    top: ").concat(paddingFloat ? '0' : '50%', ";\n    padding: ").concat(paddingFloat ? '12px' : '0 0 0 12px', ";\n    transform: translateY(").concat(paddingFloat ? '0' : '-50%', ");\n    white-space: nowrap;\n    ");
}, function (_ref5) {
  var isErrored = _ref5.isErrored,
      theme = _ref5.theme;
  return isErrored && "color: ".concat(theme.colors['red-400'], ";");
}, _Inputs_Common__WEBPACK_IMPORTED_MODULE_1__/* .labelAnimation */ .q);
var FieldError = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Common__FieldError",
  componentId: "sc-1n6n5jk-3"
})(["", ""], function (_ref6) {
  var theme = _ref6.theme;
  return "\n  color: ".concat(theme.colors['red-400'], ";\n  text-align: left;\n  grid-area: c;\n");
});

/***/ }),

/***/ 51338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ FormikTextInput; },
/* harmony export */   "o": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["label", "error", "textOverflowEllipsis", "errorInLabel"],
    _excluded2 = ["field", "form"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var TextInput = function TextInput(_ref) {
  var label = _ref.label,
      error = _ref.error,
      textOverflowEllipsis = _ref.textOverflowEllipsis,
      errorInLabel = _ref.errorInLabel,
      inputProps = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var floatLabel = !!inputProps.value;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_Common__WEBPACK_IMPORTED_MODULE_1__/* .InputWrapper */ .SP, {
      fixedHeight: true,
      isErrored: !!error,
      errorInLabel: errorInLabel,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_1__/* .InputLabel */ .AZ, {
        floatLabel: floatLabel,
        isErrored: errorInLabel && !!error,
        children: errorInLabel && !!error ? error : label
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_1__/* .StyledInput */ .Fy, _objectSpread({
        textOverflowEllipsis: textOverflowEllipsis,
        isErrored: !!error && !errorInLabel,
        floatLabel: floatLabel
      }, inputProps))]
    })
  });
};
var FormikTextInput = function FormikTextInput(_ref2) {
  var field = _ref2.field,
      form = _ref2.form,
      props = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded2);

  var error = form.touched[field.name] && form.errors[field.name];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(TextInput, _objectSpread(_objectSpread(_objectSpread({}, props), field), {}, {
      error: error,
      onBlur: form.handleBlur
    })), error && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_Common__WEBPACK_IMPORTED_MODULE_1__/* .FieldError */ .cp, {
      children: error
    })]
  });
};

/***/ }),

/***/ 88518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tl": function() { return /* reexport */ FormikDropdown; },
  "WA": function() { return /* reexport */ Text/* FormikTextInput */.W; },
  "xg": function() { return /* reexport */ InlineCountryCodeInput; },
  "hC": function() { return /* reexport */ OneLineForm; }
});

// UNUSED EXPORTS: Dropdown, FormikTextArea, TextArea, TextInput

// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/Text.js
var Text = __webpack_require__(51338);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Icons.js
var Icons = __webpack_require__(40815);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/Dropdown.js


var _excluded = ["form", "field"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Dropdown__DropdownWrapper",
  componentId: "sc-1m6rrow-0"
})(["width:100%;position:relative;display:inline-block;"]);
var StyledDropdown = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "sc-1m6rrow-1"
})(["", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      error = _ref.error;
  return "\n    width: 100%;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    background: none;\n    appearance: none;\n    border: 1px solid black;\n    background-color: ".concat(theme.colors.white, ";\n    padding: 14px 16px;\n    border-radius: 22px;\n    text-overflow: ellipsis;\n    font-size: ").concat(theme.fontSizes.xs, ";\n    line-height: 1.2;\n    transition: outline 0.1s ease-in;\n\n    outline: 1px solid ").concat(error ? theme.colors['red-400'] : 'transparent', ";\n\n    &:focus {\n      outline: 1px solid ").concat(error ? theme.colors['red-400'] : theme.colors['blue-300'], ";\n    }\n  ");
}, index_esm/* color */.$_, index_esm/* border */.Cg);
var Option = styled_components_browser_esm/* default.option.withConfig */.ZP.option.withConfig({
  displayName: "Dropdown__Option",
  componentId: "sc-1m6rrow-2"
})(["padding:10px;color:", ";", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, function (_ref3) {
  var empty = _ref3.empty;
  return empty ? "display: none;" : '';
});
var DropdownArrow = (0,styled_components_browser_esm/* default */.ZP)(Icons/* DropDownArrowIcon */.PV).withConfig({
  displayName: "Dropdown__DropdownArrow",
  componentId: "sc-1m6rrow-3"
})(["right:0;width:9px;height:9px;margin:20px;position:absolute;pointer-events:none;display:inline-block;"]);
var Dropdown = function Dropdown(_ref4) {
  var error = _ref4.error,
      options = _ref4.options,
      name = _ref4.name,
      value = _ref4.value,
      onChange = _ref4.onChange,
      placeholder = _ref4.placeholder;
  var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();

  if (!options) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DropdownWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledDropdown, {
      error: error,
      name: name,
      value: value,
      onChange: onChange,
      children: [placeholder && /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
        value: "",
        disabled: true,
        selected: true,
        hidden: true,
        children: placeholder
      }), options.map(function (_ref5) {
        var label = _ref5.label,
            optionValue = _ref5.value;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
          value: optionValue,
          selected: optionValue === value,
          children: label
        }, optionValue);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DropdownArrow, {
      color: theme.colors.greyDark
    })]
  });
};
var FormikDropdown = function FormikDropdown(_ref6) {
  var form = _ref6.form,
      field = _ref6.field,
      props = (0,objectWithoutProperties/* default */.Z)(_ref6, _excluded);

  var error = form.touched[field.name] && form.errors[field.name];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, _objectSpread(_objectSpread(_objectSpread({}, field), props), {}, {
    error: error
  }));
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/Common.js
var Common = __webpack_require__(55573);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Inputs/Common.js
var Inputs_Common = __webpack_require__(75825);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/TextArea.js


var TextArea_excluded = (/* unused pure expression or super */ null && (["label", "error"])),
    _excluded2 = (/* unused pure expression or super */ null && (["field", "form"]));

function TextArea_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TextArea_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TextArea_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TextArea_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var TextArea = function TextArea(_ref) {
  var label = _ref.label,
      error = _ref.error,
      inputProps = _objectWithoutProperties(_ref, TextArea_excluded);

  var floatLabel = !!inputProps.value;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(InputWrapper, {
      isErrored: !!error,
      children: [/*#__PURE__*/_jsx(InputLabel, {
        paddingFloat: true,
        floatLabel: floatLabel,
        children: label
      }), /*#__PURE__*/_jsx(StyledInput, TextArea_objectSpread({
        rows: "5",
        as: "textarea",
        isErrored: !!error,
        floatLabel: floatLabel
      }, inputProps))]
    }), error && /*#__PURE__*/_jsx(FieldError, {
      children: error
    })]
  });
};
var FormikTextArea = function FormikTextArea(_ref2) {
  var field = _ref2.field,
      form = _ref2.form,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx(TextArea, TextArea_objectSpread(TextArea_objectSpread(TextArea_objectSpread({}, field), props), {}, {
    error: form.touched[field.name] && form.errors[field.name]
  }));
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/ilenia/dist/useTranslations.js
var useTranslations = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/styling/index.js
var styling = __webpack_require__(50539);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/InlineCountryCodeInput.js



function InlineCountryCodeInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InlineCountryCodeInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InlineCountryCodeInput_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InlineCountryCodeInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var InlineDropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InlineCountryCodeInput__InlineDropdownWrapper",
  componentId: "sc-1lcotrt-0"
})(["grid-gap:14px;display:grid;@media (", "){grid-template-columns:1fr 3fr;}"], styling/* tablets */.Ye);
var InlineCountryCodeInput = function InlineCountryCodeInput(props) {
  var field = props.field,
      form = props.form,
      countryMenuItems = props.countryMenuItems;

  var _useTranslations = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations2 = (0,slicedToArray/* default */.Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  var error = form.touched[field.name] && form.errors[field.name];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InlineDropdownWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown, {
        name: "country",
        placeholder: translations['forms/fields/country'],
        value: form.values.country,
        onChange: form.handleChange,
        options: countryMenuItems,
        error: form.touched[field.name] && !form.values.country ? true : undefined
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Text/* TextInput */.o, InlineCountryCodeInput_objectSpread(InlineCountryCodeInput_objectSpread(InlineCountryCodeInput_objectSpread({}, props), field), {}, {
        error: error,
        onBlur: form.handleBlur
      }))]
    }), error && /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* FieldError */.cp, {
      children: error
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/styling/breakpoints.js
var breakpoints = __webpack_require__(39430);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Box.js
var Box = __webpack_require__(15458);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandButtons/index.js
var NewBrandButtons = __webpack_require__(95641);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/Form.js


var Form_excluded = ["inputJsx", "buttonJsx", "wrapOnMobile"];

function Form_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Form_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Form_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Form_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Form_InputWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* Box */.x).withConfig({
  displayName: "Form__InputWrapper",
  componentId: "sc-1gafw91-0"
})(["border-radius:30px;padding:10px;gap:8px;overflow:hidden;@media (", "){border-radius:100px;max-width:580px;}", "{height:100%;}"], breakpoints/* tablets */.Ye, NewBrandButtons/* Button */.z);
var OneLineForm = function OneLineForm(_ref) {
  var inputJsx = _ref.inputJsx,
      buttonJsx = _ref.buttonJsx,
      _ref$wrapOnMobile = _ref.wrapOnMobile,
      wrapOnMobile = _ref$wrapOnMobile === void 0 ? false : _ref$wrapOnMobile,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, Form_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Box/* Box */.x, {
    as: "form",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Form_InputWrapper, Form_objectSpread(Form_objectSpread({
      display: "flex",
      bg: "white",
      flexGap: "8px",
      mx: "auto",
      my: 0,
      alignItems: ['stretch',, 'center']
    }, props), {}, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
        flexGrow: 1,
        children: inputJsx
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
        display: wrapOnMobile ? ['none',, 'block'] : undefined,
        children: buttonJsx
      })]
    })), /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
      display: wrapOnMobile ? ['block',, 'none'] : 'none',
      children: buttonJsx
    })]
  });
};
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandInputs/index.js






/***/ }),

/***/ 20014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xF": function() { return /* binding */ NewBrandRichText; },
  "Zr": function() { return /* binding */ RichTextHyperLink; }
});

// UNUSED EXPORTS: HR, richTextEntryRenderer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(86437);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Box.js
var Box = __webpack_require__(15458);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Headers/index.js
var Headers = __webpack_require__(1723);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/content-blocks/CTA/index.js + 1 modules
var CTA = __webpack_require__(39471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/Tooltip.js





var ReactTooltip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 4762).then(__webpack_require__.bind(__webpack_require__, 24762));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(24762)];
    }
  }
});
var TooltipText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Tooltip__TooltipText",
  componentId: "sc-10mz1v3-0"
})(["display:block;font-weight:400;font-family:'TrustpilotDefaultFont',Arial,monospace;"]);
var StyledReactTooltip = (0,styled_components_browser_esm/* default */.ZP)(ReactTooltip).withConfig({
  displayName: "Tooltip__StyledReactTooltip",
  componentId: "sc-10mz1v3-1"
})(["max-width:240px;box-shadow:0px 0px 10px 0px rgb(0 0 0 / 30%);border-radius:8px !important;&.show{opacity:1 !important;}"]);
var Tooltip = function Tooltip(_ref) {
  var id = _ref.sys.id,
      referenceTitle = _ref.referenceTitle,
      text = _ref.tooltipText.tooltipText;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      "data-tip": true,
      "data-for": id,
      children: referenceTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledReactTooltip, {
      id: id,
      place: "top",
      wrapper: "span",
      type: "light",
      multiline: true,
      textColor: "black",
      backgroundColor: "white",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TooltipText, {
        children: text
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/styling/breakpoints.js
var breakpoints = __webpack_require__(39430);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Video/index.js
var Video = __webpack_require__(49085);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/restMapper.js
var restMapper = __webpack_require__(27786);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Buttons/index.js
var Buttons = __webpack_require__(23012);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Links/index.js + 1 modules
var Links = __webpack_require__(17221);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/richtext.js
var isEmptyParagraph = function isEmptyParagraph(node) {
  return node.nodeType === 'paragraph' && node.content.length === 1 && node.content[0].nodeType === 'text' && node.content[0].value === '';
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/constants/widths.js
var widths = __webpack_require__(78033);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/renderers.js
var renderers = __webpack_require__(96264);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/content-blocks/ResourceQuote/index.js
var ResourceQuote = __webpack_require__(3493);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/content-blocks/ResourceImage/index.js
var ResourceImage = __webpack_require__(2774);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Image/index.js
var Image = __webpack_require__(40609);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/content-blocks/LinkDivider/index.js
var LinkDivider = __webpack_require__(97906);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/NewBrandRichText.js



var _excluded = ["content", "data", "children"],
    _excluded2 = ["isFullPageWidth", "contentAlignment"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var fontWeightMap = {
  Normal: 400,
  Bold: 500,
  Boldest: 600
};

var getListStyleType = function getListStyleType(listStyle) {
  switch (listStyle) {
    case 'circle-outline':
      return 'circle';

    case 'square':
      return 'square';

    case 'dash':
      return '"- "';

    default:
      return 'disc';
  }
};

var ResponsiveImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NewBrandRichText__ResponsiveImageWrapper",
  componentId: "sc-questw-0"
})(["max-width:", ";", ""], function (_ref) {
  var isFullPageWidth = _ref.isFullPageWidth;
  return isFullPageWidth ? '100%' : "".concat(widths/* STANDARD_ARTICLE_WIDTH */.q4, "px");
}, function (_ref2) {
  var contentAlignment = _ref2.contentAlignment;
  return contentAlignment === 'center' && 'margin: auto';
});
var HR = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
  displayName: "NewBrandRichText__HR",
  componentId: "sc-questw-1"
})(["margin-top:5rem;margin-bottom:5rem;"]);
var SmallArrowedLink = (0,styled_components_browser_esm/* default */.ZP)(Links/* ArrowedLink */.aB).withConfig({
  displayName: "NewBrandRichText__SmallArrowedLink",
  componentId: "sc-questw-2"
})(["", " ", " display:inline-block;"], index_esm/* space */.Dh, index_esm/* typography */.cp);
var SmallLink = (0,styled_components_browser_esm/* default */.ZP)(Links/* Link */.rU).withConfig({
  displayName: "NewBrandRichText__SmallLink",
  componentId: "sc-questw-3"
})(["text-decoration:underline;", ""], index_esm/* typography */.cp);
var RichTextHyperLink = function RichTextHyperLink(_ref3) {
  var content = _ref3.content,
      data = _ref3.data,
      children = _ref3.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  if (content.length === 1 && content[0].value.endsWith('→')) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallArrowedLink, _objectSpread(_objectSpread({
      href: data === null || data === void 0 ? void 0 : data.uri,
      mt: 6,
      fontSize: "sm"
    }, restProps), {}, {
      children: content[0].value.replace('→', '').trim()
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(SmallLink, _objectSpread(_objectSpread({
    href: data === null || data === void 0 ? void 0 : data.uri,
    fontSize: "sm"
  }, restProps), {}, {
    children: children
  }));
};

var ResourceSpacing = function ResourceSpacing(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, _objectSpread(_objectSpread({}, props), {}, {
    my: [3,,, 4]
  }));
};

var ButtonWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "NewBrandRichText__ButtonWrapper",
  componentId: "sc-questw-4"
})(["display:inline-block;margin:10px 10px 10px 0;"]);
var richTextEntryRenderer = {
  resourceImage: function resourceImage(_ref4) {
    var isFullPageWidth = _ref4.isFullPageWidth,
        contentAlignment = _ref4.contentAlignment,
        props = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded2);

    return /*#__PURE__*/(0,jsx_runtime.jsx)(ResponsiveImageWrapper, {
      isFullPageWidth: isFullPageWidth,
      contentAlignment: contentAlignment,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceImage.ResourceImage, _objectSpread({}, props))
    });
  },
  responsiveImage: function responsiveImage(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Image/* ResponsiveContentfulImage */.lB, _objectSpread({}, props));
  },
  componentCta: function componentCta(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CTA/* CTA */.M, _objectSpread({}, props));
  },
  resourceVideo: function resourceVideo(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Video.ResourceVideo, _objectSpread({
      spacing: {}
    }, props));
  },
  video: function video(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Video.ResourceVideo, _objectSpread({
      spacing: {}
    }, props));
  },
  button: function button(props) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* ButtonFromType */.t3, _objectSpread(_objectSpread({}, props), {}, {
        href: props.link
      }))
    });
  },
  quote: ResourceQuote.ResourceQuote,
  tooltip: Tooltip,
  linkDivider: LinkDivider.ResourceLinkDivider,
  'image/svg+xml': function imageSvgXml(_ref5) {
    var fields = _ref5.fields;
    return /*#__PURE__*/(0,jsx_runtime.jsx)("img", _objectSpread(_objectSpread(_objectSpread({}, fields), fields.file), {}, {
      src: fields.file.url
    }));
  }
};
var RichtextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "NewBrandRichText__RichtextWrapper",
  componentId: "sc-questw-5"
})(["", ""], function (_ref6) {
  var contentAlignment = _ref6.contentAlignment,
      _ref6$removeChildTopM = _ref6.removeChildTopMargin,
      removeChildTopMargin = _ref6$removeChildTopM === void 0 ? true : _ref6$removeChildTopM,
      _ref6$removeChildBott = _ref6.removeChildBottomMargin,
      removeChildBottomMargin = _ref6$removeChildBott === void 0 ? true : _ref6$removeChildBott;
  return "\n    text-align: center;\n\n    @media(".concat(breakpoints/* desktops */.qf, ") {\n      text-align: ").concat(contentAlignment, ";\n    }\n\n    ").concat(removeChildBottomMargin && "\n        *:last-child {\n        margin-bottom: 0;\n        }\n      ", "\n\n    ").concat(removeChildTopMargin && "\n        *:first-child {\n          margin-top: 0;\n        }\n      ", "\n\n    }\n  ");
});
var NewBrandRichText = function NewBrandRichText(_ref7) {
  var _objectSpread2;

  var content = _ref7.content,
      _ref7$customPrimitive = _ref7.customPrimitiveRenderer,
      customPrimitiveRenderer = _ref7$customPrimitive === void 0 ? {} : _ref7$customPrimitive,
      _ref7$customEntryRend = _ref7.customEntryRenderer,
      customEntryRenderer = _ref7$customEntryRend === void 0 ? {} : _ref7$customEntryRend,
      _ref7$customAssetRend = _ref7.customAssetRenderer,
      customAssetRenderer = _ref7$customAssetRend === void 0 ? {} : _ref7$customAssetRend,
      contentAlignment = _ref7.contentAlignment,
      listStyle = _ref7.listStyle,
      _ref7$paragraphSize = _ref7.paragraphSize,
      paragraphSize = _ref7$paragraphSize === void 0 ? 'xs' : _ref7$paragraphSize,
      _ref7$paragraphFontWe = _ref7.paragraphFontWeight,
      paragraphFontWeight = _ref7$paragraphFontWe === void 0 ? 'Normal' : _ref7$paragraphFontWe,
      removeChildBottomMargin = _ref7.removeChildBottomMargin,
      removeChildTopMargin = _ref7.removeChildTopMargin;
  var renderRichTextEntry = (0,renderers/* renderContentfulEntry */.A)(_objectSpread(_objectSpread({}, richTextEntryRenderer), customEntryRenderer), listStyle);
  var renderRichTextAsset = (0,renderers/* renderContentfulEntry */.A)(_objectSpread({
    'image/svg+xml': function imageSvgXml(_ref8) {
      var fields = _ref8.fields;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("img", _objectSpread(_objectSpread(_objectSpread({}, fields), fields.file), {}, {
        src: fields.file.url
      }));
    }
  }, customAssetRenderer));

  var contentWithTrimmedEmptyParagraphs = _objectSpread(_objectSpread({}, content), {}, {
    content: content.content.filter(function (node) {
      return !isEmptyParagraph(node);
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)(RichtextWrapper, {
    contentAlignment: contentAlignment,
    removeChildTopMargin: removeChildTopMargin,
    removeChildBottomMargin: removeChildBottomMargin,
    children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(contentWithTrimmedEmptyParagraphs, {
      renderNode: _objectSpread((_objectSpread2 = {}, (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.EMBEDDED_ENTRY, function (node) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceSpacing, {
          children: renderRichTextEntry(_objectSpread(_objectSpread({}, (0,restMapper/* restMapper */.S)(node.data.target)), {}, {
            contentAlignment: contentAlignment
          }))
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.INLINES.EMBEDDED_ENTRY, function (node) {
        return renderRichTextEntry(_objectSpread(_objectSpread({}, (0,restMapper/* restMapper */.S)(node.data.target)), {}, {
          contentAlignment: contentAlignment,
          inline: true
        }));
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.EMBEDDED_ASSET, function (node) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceSpacing, {
          children: renderRichTextAsset(node.data.target)
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.INLINES.EMBEDDED_ASSET, function (node) {
        return renderRichTextAsset(node.data.target);
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.PARAGRAPH, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* Box */.x, {
          as: "p",
          fontSize: paragraphSize,
          fontWeight: fontWeightMap[paragraphFontWeight],
          lineHeight: "1.4",
          my: [4,,, 5],
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_1, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: 5,
          size: "h1",
          as: "h2",
          fontFamily: "Trustpilot Display",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_2, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: [4,,, 5],
          as: "h2",
          fontFamily: "Trustpilot Display",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_3, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: [3,,, 4],
          as: "h3",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_4, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: [3,,, 4],
          as: "h4",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_5, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: [3,,, 4],
          as: "h5",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HEADING_6, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Headers.H, {
          my: [3,,, 4],
          as: "h6",
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.UL_LIST, function (_, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          style: {
            listStyleType: getListStyleType(listStyle)
          },
          children: children
        });
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.BLOCKS.HR, function () {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(HR, {});
      }), (0,defineProperty/* default */.Z)(_objectSpread2, dist.INLINES.HYPERLINK, function (node, children) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(RichTextHyperLink, _objectSpread(_objectSpread({}, node), {}, {
          children: children
        }));
      }), _objectSpread2), customPrimitiveRenderer),
      renderText: function renderText(text) {
        return text.split('\n').reduce(function (children, textSegment, index) {
          return [].concat((0,toConsumableArray/* default */.Z)(children), [index > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}, index), textSegment]);
        }, []);
      }
    })
  });
};

/***/ }),

/***/ 83772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dp": function() { return /* binding */ domainWithProtocolRegex; },
/* harmony export */   "HN": function() { return /* binding */ emailRegex; },
/* harmony export */   "Zf": function() { return /* binding */ domainRegex; },
/* harmony export */   "n_": function() { return /* binding */ phoneRegex; }
/* harmony export */ });
/* unused harmony export slugRegex */
var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,11}?$/;
var phoneRegex = /^[0-9 ()+-]+$/;
var domainWithProtocolRegex = /^(?:http:\/\/|https:\/\/)?(?:www\.)?(?:(\S+)\.)?(\S+)\.(\S+?)?(?:\/\S*)?$/;
var slugRegex = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;

/***/ })

}]);